export default "__VITE_ASSET__XfqAZU1t__"